import { createFileRoute, redirect } from "@tanstack/react-router";
import { useStore } from "zustand";
import { uiStore } from "@/lib/stores/ui-store";

export const Route = createFileRoute("/app/$channelId/")({
	component: ChannelComponent,
});

function ChannelComponent() {
	const navigate = useStore(uiStore, (state) => state.navigate);
	const { channelId } = Route.useParams();
	navigate({ type: "textChannel", params: { channelId } });
	throw redirect({ to: "/app" });
}
